import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaSearch, FaSlidersH } from "react-icons/fa"; // React Icons
import Carousel from "../components/Carousel";
import { Link } from "react-router-dom";

// sevices imgs
import service1 from "../assets/digitalparag/1.jpeg";
import service2 from "../assets/digitalparag/2.jpg";
import service3 from "../assets/digitalparag/3.jpeg";
// import service4 from '../assets/digitalparag/4.jpeg'
import service5 from "../assets/digitalparag/5.jpg";
import service6 from "../assets/digitalparag/6.jpg";
import service7 from "../assets/digitalparag/7.jpg";
import service8 from "../assets/digitalparag/8.jpeg";
import service9 from "../assets/digitalparag/9.jpeg";
import service10 from "../assets/digitalparag/10.jpg";
import service11 from "../assets/digitalparag/11.png";
import service12 from "../assets/digitalparag/merger-retention.jpg";

const Home = () => {
  return (
    <div>
      <Header />
      {/* slider */}
      <div>
        {" "}
        {/* <br /> */}
        {/* <Carousel /> */}
      </div>

      {/* Services */}

      <div className="bg-slate-100 py-4">
        <div className="text-center mb-4 mt-5">
          {/* <h2 className="text-3xl font-b  old mb-2 text-blue-500">Our Services</h2> */}
          <p className="text-2xl">
            Empowering Maharashtra Zilla Parishad Employees with Smart,
          </p>
          <p className="text-2xl">
            Paperless Solutions – Simplify, Streamline, Succeed!
          </p>
        </div>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-9 m-auto">
              <div className="row">
                <div className="col-lg-4 col-12 mt-3">
                  <Link
                    to={"/da_calculation"}
                    className="card group w-full h-100 overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
                  >
                    <div className="align-items-center">
                      <img
                        className="object-cover w-full h-48"
                        src={service1}
                        alt="Make pan card Sitting at Home"
                      />
                      <div className="p-3 text-center">
                        <div className="block pb-3 text-lg font-bold text-gray-800 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                          DA Calculation
                        </div>
                        <span className="text-sm text-gray-700 dark:text-gray-200">
                          शासनाने वेळोवेळी वाढ केलेला महागाई भत्ता, त्यामुळे
                          आपल्या पगारात किती वाढ होते, ते पहा{" "}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-12 mt-3">
                  <Link
                    to={"/govt_books_gr"}
                    className="card group w-full h-100 overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
                  >
                    <div className="align-items-center">
                      <img
                        className="object-cover w-full h-48"
                        src={service2}
                        alt="Make Tredmark Sitting at Home"
                      />
                      <div className="p-3 text-center">
                        <div className="block pb-3 text-lg font-bold text-gray-800 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                          Govt Books & GR
                        </div>
                        <span className="text-sm text-gray-700 dark:text-gray-200">
                          शासनाने जिल्हा परिषद कर्मचाऱ्यांसाठी नियत केलेले
                          पुस्तके व महत्वाचे शासन निर्णय (विषय निहाय){" "}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-12 mt-3">
                  <Link
                    to={"/sign_in"}
                    className="card group w-full  h-100 overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
                  >
                    <div className="align-items-center">
                      <img
                        className="object-cover w-full h-48"
                        src={service3}
                        alt="incometax_calcuation"
                      />
                      <div className="p-3 text-center">
                        <div className="block pb-3 text-lg font-bold text-gray-800 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                          Income Tax Calculation
                        </div>
                        <span className="text-sm text-gray-700 dark:text-gray-200">
                          सर्व शासकीय कर्मचारी यांना आयकर गणना तक्ता आपल्या
                          कार्यालयात सादर करणे आवश्यक आहे, त्यासाठी आपण आपला
                          आयकर गणना तक्ता तयार करावा.{" "}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-lg-4 col-12 mt-3">
                  <Link
                    to={"/sign_in"}
                    className="card group w-full h-100 overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
                  >
                    <div className=" align-items-center">
                      <img
                        className="object-cover w-full h-48"
                        src={service5}
                        alt="Make Food license Sitting at Home"
                      />
                      <div className="p-3 text-center">
                        <div className="block pb-3 text-lg font-bold text-gray-800 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                          Inter District Transfer
                        </div>
                        <span className="text-sm text-gray-700 dark:text-gray-200">
                          ज्या जिल्हा परिषद कर्मचाऱ्यांना एका जिल्ह्यातून
                          दुसऱ्या जिल्ह्यात बदली करून जायचे आहे, त्यांच्यासाठी
                          हा प्रस्ताव आहे.{" "}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-12 mt-3">
                  <Link
                    to={"/sign_in"}
                    className="card group w-full h-100 overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
                  >
                    <div className=" align-items-center">
                      <img
                        className="object-cover w-full h-48"
                        src={service6}
                        alt="Make Company registration Sitting at Home"
                      />
                      <div className="p-3 text-center">
                        <div className="block pb-3 text-lg font-bold text-gray-800 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                          GPF Propasal (Non-Refundable)
                        </div>
                        <span className="text-sm text-gray-700 dark:text-gray-200">
                          सेवेत कार्यरत असतांना जिल्हा परिषद कर्मचाऱ्यांसाठी
                          भविष्य निर्वाह निधी (ना-परतावा ) प्रस्ताव तयार करणे.{" "}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-12 mt-3">
                  <Link
                    to={"/sign_in"}
                    className="card group w-full h-100 overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
                  >
                    <div className="align-items-center">
                      <img
                        className="object-cover w-full h-48"
                        src={service7}
                        alt="Make Import Export Code Sitting at Home"
                      />
                      <div className="p-3 text-center">
                        <div className="block pb-3 text-lg font-bold text-gray-800 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                          GPF Propasal (Final)
                        </div>
                        <span className="text-sm text-gray-700 dark:text-gray-200">
                          सेवा निवृत्त होणारे कर्मचारी यांचा भविष्य निर्वाह निधी
                          (अंतिम) प्रस्ताव तयार करणे.{" "}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-lg-4 col-12 mt-3">
                  <Link
                    to={"/sign_in"}
                    className="card group w-full h-100 overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
                  >
                    <div className=" align-items-center">
                      <img
                        className="object-cover w-full h-48"
                        src={service8}
                        alt="Make Digital Signature Sitting at Home"
                      />
                      <div className="p-3 text-center">
                        <div className="block pb-3 text-lg font-bold text-gray-800 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                          Pension Propasal
                        </div>
                        <span className="text-sm text-gray-700 dark:text-gray-200">
                          सेवा निवृत्त होणारे कर्मचारी यांचा निवृत्ती वेतन
                          प्रस्ताव तयार करणे.{" "}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-12 mt-3">
                  <Link
                    to={"/sign_in"}
                    className="card group w-full h-100 overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
                  >
                    <div className="align-items-center">
                      <img
                        className="object-cover w-full h-48"
                        src={service9}
                        alt="Make Legal Consultancy Sitting at Home"
                      />
                      <div className="p-3 text-center">
                        <div className="block pb-3 text-lg font-bold text-gray-800 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                          GIS Propasal (Final)
                        </div>
                        <span className="text-sm text-gray-700 dark:text-gray-200">
                          सेवा निवृत्त होणारे कर्मचारी यांचा गट विमा प्रस्ताव
                          तयार करणे.{" "}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-12 mt-3">
                  <Link
                    to={"/sign_in"}
                    className="card group w-full h-100 overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
                  >
                    <div className="align-items-center">
                      <img
                        className="object-cover w-full h-48"
                        src={service10}
                        alt="Make ITR Filing Sitting at Home"
                      />
                      <div className="p-3 text-center">
                        <div className="block pb-3 text-lg font-bold text-gray-800 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                          Leave Encashment Propasal (Final)
                        </div>
                        <span className="text-sm text-gray-700 dark:text-gray-200">
                          सेवा निवृत्त होणारे कर्मचारी यांचा रजा रोखीकरण
                          प्रस्ताव तयार करणे.{" "}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              {/* <div className="row mt-4">
                <div className="col-lg-4 col-12 mt-3">
                  <Link
                    to={"/food_lic"}
                    className="card group w-full overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
                  >
                    <div className="align-items-center">
                      <img
                        className="object-cover w-full h-48"
                        src={service12}
                        alt="Make FSSAI Annual return filling Sitting at Home"
                      />
                      <div className="p-3 text-center">
                        <div className="block pb-3 text-lg font-bold text-gray-800 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                          PAY FIXATION (Final)
                        </div>
                        <span className="text-sm text-gray-700 dark:text-gray-200">
                          Regular Pramotion, time Bound Pramotion Fixation तयार
                          करणे.{" "}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-4 col-12 mt-3">
                  <Link
                    to={"/food_lic"}
                    className="card group w-full overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:shadow-xl transform hover:scale-105 transition-transform duration-300"
                  >
                    <div className="row align-items-center">
                      <div className="col-lg-6">
                        <img
                          className="object-cover w-full h-48"
                          src={service11}
                          alt="Make FSSAI Annual return filling Sitting at Home"
                        />
                      </div>
                      <div className="col-lg-6 pb-3">
                        <div className="block pb-3 text-lg font-bold text-gray-800 dark:text-white group-hover:text-orange-500 transition-colors duration-300">
                          Website Design
                        </div>
                        <span className="text-sm text-gray-700 dark:text-gray-200">
                          वेबसाईट डिझाईन म्हणजे वेब पृष्ठांची आकर्षक आणि कार्यक्षम
                          रचना तयार करणे. चांगले डिझाईन वापरकर्त्यांना माहिती सहजपणे
                          शोधण्यास मदत करते आणि वेबसाइटच्या उद्दिष्टांना पोहोचण्यास
                          मदत करते.
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
